<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { Bars3Icon } from '@heroicons/vue/16/solid';
    import { cn } from '../utils';
    import { Button } from '../Button';
    import { useSidebar } from './utils';

    const props = defineProps<{
        class?: HTMLAttributes['class'];
    }>();

    const { toggleSidebar } = useSidebar();
</script>

<template>
    <Button
        data-sidebar="trigger"
        data-slot="sidebar-trigger"
        variant="tertiary"
        icon
        :class="cn('h-7 w-7', props.class)"
        @click="toggleSidebar"
    >
        <Bars3Icon />
        <span class="sr-only">Toggle Sidebar</span>
    </Button>
</template>
